import React from 'react';
import { Grid, GridItem } from 'components/UI/Grid';
import CounterBox from 'components/UI/CounterBox';
import Hint from 'components/UI/Hint';
import Markup from 'components/Markup';
import { observer } from 'store';
import { DEFAULT_COLS } from '../../../constants';
import { useCountersHandlers } from '../../../hooks';
import { useTrans } from 'utils/localisation';
import * as styles from './counter.module.scss';

function Desktop({
  items,
  getCounterValue,
  shouldShowHints,
  onChangeCount,
  sectionIndex,
  cols = DEFAULT_COLS,
}) {
  const { increment, decrement } = useCountersHandlers(onChangeCount);
  const t = useTrans(['calculatorHints']);

  return (
    <Grid gutterX={0} {...cols}>
      {items.map((item, i) => {
        const value = getCounterValue(item);
        const labelId = `desktop-counter-label-${sectionIndex}-${i}`;

        return (
          <GridItem key={item} Tag="div">
            <div className={styles.counter}>
              <CounterBox
                value={value}
                increment={() => increment(item, value)}
                decrement={() => decrement(item, value)}
                labelId={labelId}
              />
              <div id={labelId} className={styles.title}>
                {item}
                {shouldShowHints && t(item) && (
                  <span className={styles.hint}>
                    <Hint withIcon showOnlyOne content={<Markup>{t(item)}</Markup>} zIndex={100} />
                  </span>
                )}
              </div>
            </div>
          </GridItem>
        );
      })}
    </Grid>
  );
}

export default observer(Desktop);
